import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {Buffer} from 'buffer';

class Menu extends Component {
    getCategoryLabel(category) {
        return category.main_category_name || category.sub_category_name || category.final_category_name || '';
    }

    getCategoryId(category) {
        return category.main_category_id || category.sub_category_id || category.final_category_id || '';
    }

    getChildCategories(category) {
        const subCategories = Array.isArray(category.sub_category_list) ? category.sub_category_list : [];
        const finalCategories = Array.isArray(category.final_category_list) ? category.final_category_list : [];

        return subCategories.length > 0 ? subCategories : finalCategories;
    }

    renderCategoryItems(categories) {
        return categories.map((category, index) => {
            const label = this.getCategoryLabel(category);
            const children = this.getChildCategories(category);
            const categoryId = this.getCategoryId(category);
            const hasChildren = children.length > 0;

            if (hasChildren) {
                return (
                    <li className="menu-item-has-children" key={`${label}-${categoryId || index}`}>
                        <Link to="/" onClick={(event) => event.preventDefault()}>
                            {label}
                        </Link>
                        <span className="sub-toggle"><i className="fa fa-chevron-down"></i></span>
                        <ul className="sub-menu">
                            {this.renderCategoryItems(children)}
                        </ul>
                    </li>
                );
            }

            const categoryPath = `/products/category/${Buffer.from(String(categoryId)).toString('base64')}/${encodeURIComponent(label)}`;

            return (
                <li key={`${label}-${categoryId || index}`}>
                    <Link to={categoryPath}>{label}</Link>
                </li>
            );
        });
    }

    renderCategoryDropdown() {
        const menu = Array.isArray(this.props.menu) ? this.props.menu : [];

        return (
            <li className="menu-item-has-children ps-main-menu__categories">
                <Link to="/" onClick={(event) => event.preventDefault()}>
                    Shop All
                </Link>
                <span className="sub-toggle"><i className="fa fa-chevron-down"></i></span>
                <ul className="sub-menu">
                    {this.renderCategoryItems(menu)}
                </ul>
            </li>
        );
    }

    render() {
        return (
            <nav className="ps-main-menu">
                <ul className="menu">
                    {this.renderCategoryDropdown()}
                    <li><Link to="/aboutus">About Natureway</Link></li>
                    <li className="menu-item-has-children">
                        <Link to="/" onClick={(event) => event.preventDefault()}>
                            Our Policies
                        </Link>
                        <span className="sub-toggle"><i className="fa fa-chevron-down"></i></span>
                        <ul className="sub-menu">
                            <li><Link to="/privacypolicy">Privacy Policy</Link></li>
                            <li><Link to="/deliveryinfo">Shipping Policy</Link></li>
                            <li><Link to="/refundpolicy">Refund Policy</Link></li>
                            <li><Link to="/terms">Terms of Service</Link></li>
                        </ul>
                    </li>
                    <li><Link to="/contactus">Contact us</Link></li>
                </ul>
            </nav>
        );
    }
}

export default Menu;
